import styled, { css } from 'styled-components'

const footerButtonBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, opacity 0.2s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const FormFooter = styled.footer`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
`

export const PrimaryActions = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  min-width: 0;
`

export const CancelButton = styled.button`
  ${footerButtonBase};
  background: #f0f0f0;
  color: #4c4c4c;

  &:hover:not(:disabled) {
    background: #e0e0e0;
    color: #363636;
  }
`

export const PreviewButton = styled.button`
  ${footerButtonBase};
  background: #f0f0f0;
  color: #4c4c4c;

  &:hover:not(:disabled) {
    background: #e0e0e0;
    color: #363636;
  }
`

export const SaveExitButton = styled.button`
  ${footerButtonBase};
  background: #e7f3fe;
  color: #0085ff;

  &:hover:not(:disabled) {
    background: #cce7fc;
    color: #0070d9;
  }
`

export const SaveLessonsButton = styled.button`
  ${footerButtonBase};
  background: #0085ff;
  color: #fff;

  &:hover:not(:disabled) {
    background: #0070d9;
    color: #fff;
  }

  svg {
    width: 16px;
    height: 16px;
    font-size: 16px;
  }
`
